import request from '@host-panel/request';

type Response = {
  results: { [messageId in string]: boolean };
};

export default function approveItems(messageIds: string[], usePrefix = false): Promise<Response> {
  const prefix = usePrefix ? '/host-panel' : '';

  return request(`${prefix}/moderation/messages/approve`, {
    method: 'POST',
    data: {
      message_ids: messageIds
    }
  });
}
